@if(detailsVisible$$()) {
    <div class="details-page"
        [@showHide]="{ value: '', params: { enterTime: _detailsEnterTime$$(), leaveTime: _showHideLeaveTime$$() } }"
        (@showHide.start)="emit_animation_start()"
        (@showHide.done)="emit_animation_end()"
    >
        <ng-container *ngTemplateOutlet="sectionDetails_template$$()" />
    </div>
}
@if(sectionEditShow$$()) {
    <div class="edit-page"
        [class.edit-page--pending]="editPending$$()"
        [class.edit-page--reveal]="editGated$$() && !editPending$$()"
        [@showHide]="{ value: '', params: { enterTime: _editEnterTime$$(), leaveTime: _showHideLeaveTime$$() } }"
        (@showHide.start)="emit_animation_start()"
        (@showHide.done)="emit_animation_end()"
    >
        <ng-container *ngTemplateOutlet="sectionEdit_template$$()" />
    </div>
}

<ng-template #sectionDetails_buttons>
    <app-button-block-details-section class="buttons-block" [@show]
        (onBtnDelete)="emit_btnDelete()"
        (onBtnEdit)="emit_btnEdit()"
        [templateExtraButtons]="sectionDetails_extraButtons$$()"
    />
</ng-template>

<ng-template #sectionEdit_buttons>
    <app-button-block-edit-section class="buttons-block" [@show]
        (onBtnCancel)="emit_btnCancel()"
        (onBtnSave)="emit_btnSave()"
        [templateExtraButtons]="sectionEdit_extraButtons$$()"
    />
</ng-template>
